var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    [
      _c(
        "q-collapsible",
        {
          attrs: {
            icon: "far fa-star",
            label: _vm.$t("featured"),
            opened: !_vm.$q.platform.is.mobile ? true : false
          }
        },
        _vm._l(_vm.featuredCategories, function(category, index) {
          return _c(
            "q-card",
            {
              key: index,
              staticClass: "text-white q-mr-sm q-mt-sm cursor-pointer",
              class: _vm.getBg(category.value),
              staticStyle: { width: "150px", height: "150px" },
              attrs: { inline: "" },
              nativeOn: {
                click: function($event) {
                  return _vm.clickCategory(category.value)
                }
              }
            },
            [
              _c(
                "q-card-media",
                { staticClass: "text-center q-pt-md" },
                [
                  _c("q-icon", { attrs: { name: category.icon, size: "3rem" } })
                ],
                1
              ),
              _c("q-card-main", { staticClass: "text-center uppercase" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(category.label) +
                    "\n            "
                )
              ])
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }